/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createWebhusetOrderApiFeaturesCartCouponPutResponseFromDiscriminatorValue, serializeWebhusetOrderApiFeaturesCartCouponPutRequest, serializeWebhusetOrderApiFeaturesCartCouponPutResponse, type WebhusetOrderApiFeaturesCartCouponPutRequest, type WebhusetOrderApiFeaturesCartCouponPutResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /cart/{cartId}/coupon
 */
export interface CouponRequestBuilder extends BaseRequestBuilder<CouponRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<WebhusetOrderApiFeaturesCartCouponPutResponse>}
     */
     put(body: WebhusetOrderApiFeaturesCartCouponPutRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<WebhusetOrderApiFeaturesCartCouponPutResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: WebhusetOrderApiFeaturesCartCouponPutRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const CouponRequestBuilderUriTemplate = "{+baseurl}/cart/{cartId}/coupon";
/**
 * Metadata for all the requests in the request builder.
 */
export const CouponRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: CouponRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory:  createWebhusetOrderApiFeaturesCartCouponPutResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeWebhusetOrderApiFeaturesCartCouponPutRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
